import { useEffect, useRef } from "react";

const clampTextToLines = (el: HTMLElement, lines: number) => {
  const style = window.getComputedStyle(el);
  const lineHeight = parseFloat(style.lineHeight);

  if (!lineHeight || isNaN(lineHeight)) return;

  const maxHeight = lineHeight * lines;
  const originalText = el.innerText.trim();
  let text = originalText;

  while (el.scrollHeight > maxHeight && text.length > 0) {
    text = text.slice(0, -1).trim();
    el.innerText = text + "…";
  }

  // Fallback if clamp fails too early
  if (el.scrollHeight > maxHeight && text.length < 5) {
    el.innerText = originalText;
  }
};

export const useLineClamp = (lines: number) => {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      clampTextToLines(ref.current, lines);
    }
  }, [lines]);

  return ref;
};
